/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Wrapper
 */
export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  #map {
    width: 100%;
    height: 100%;

    @media (max-width: 768px) {
      .leaflet-control-zoom {
        display: none;
      }
    }
  }

  .loader {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.6);
    color: #5e5e5e;
    z-index: 2000;
    @media (max-width: 768px) {
      height: calc(50vh - 53px);
      top: 60px;
    }
  }
`;
